<template>
  <a-modal v-model="modal" title="新建" width="500px" :maskClosable="false" :closable="false">
    <div class="main-part">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="计划版本"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="version"
          :rules="rules.version"
        >
          <a-input v-model="formData.version" disabled />
        </a-form-model-item>
        <a-form-model-item
          label="周版本计划"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="weekPlanVersion"
          :rules="rules.weekPlanVersion"
        >
          <global-select
            :assembleLabel="false"
            :value.sync="formData.weekPlanVersion"
            selectType="selectSearch"
            requestApi="/scp/scpMpsFdPlans/findWeekVersionList"
            :selectItem="{ value: 'realValue', label: 'label' }"
            searchParam="version" />
        </a-form-model-item>
        <a-form-model-item
          label="参数版本"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="optionVersion"
          :rules="rules.optionVersion"
        >
          <global-select
            :assembleLabel="false"
            :value.sync="formData.optionVersion"
            selectType="selectSearch"
            requestApi="/scp/scpMpsFdOptions/findOptionsVersionList"
            :selectItem="{ value: 'realValue', label: 'label' }"
            searchParam="version" />
        </a-form-model-item>
        <a-form-model-item
          label="月度计划"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="monthPlanVersion"
          :rules="rules.monthPlanVersion"
        >
          <global-select
            :value.sync="formData.monthPlanVersion"
            selectType="selectSearch"
            :default-active-first-option="true"
            requestApi="/scp/sopMonthPlan/monthPlanVersionPullDown"
            :selectItem="{ value: 'selectedValue', label: 'label' }"
            searchParam="version"
          />
        </a-form-model-item>
        <a-form-model-item
          label="版本说明"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="description"
          :rules="rules.description"
        >
          <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.description" :maxLength="50" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiScpCreateAndStartMpsFd, apiScpFindLastVersion } from '@/api/finished-goods-order'
import moment from 'moment';

export default {
  name: 'CreateMainPlan',
  data() {
    return {
      modal: false,
      formData: {
        version: "", // 计划版本
        optionVersion: '', // 参数版本
        monthPlanVersion: '', // 月度计划
        weekPlanVersion: '', // 周计划版本
        description: '' // 描述
      },
      loading: false,
      rules: {
        version: [{ required: true, message: ' ', trigger: 'change' }],
        optionVersion: [{ required: true, message: ' ', trigger: 'change' }],
        monthPlanVersion: [{ required: true, message: ' ', trigger: 'change' }],
        weekPlanVersion: [{ required: true, message: ' ', trigger: 'change' }],
        description: [{ required: true, message: ' ', trigger: 'blur' }]
      }
    }
  },
  methods: {
    moment,
    // 初始化获取最新版本
    initGetLastVersion() {
      this.loading = true
      apiScpFindLastVersion({}).then(res => {
        if (res?.code === 200) {
          this.$set(this.formData, 'version', res.data)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 初始化
    show () {
      this.initGetLastVersion();
      this.formData = {
        version: '',
        optionVersion: '',
        monthPlanVersion: '',
        weekPlanVersion: '',
        description: ''
      }
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiScpCreateAndStartMpsFd(this.formData).then(response => {
            if (response?.code === 200) {
              this.modal = false
              this.$message.success('创建成功!')
              this.$emit("refresh")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main-part{
  margin-right: 65px;
  .ant-calendar-picker{
    width: 100%
  }
}
</style>
